var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quranProgram == 1)?_c('quran-program'):(['student', 'teacher'].includes(_vm.$role))?_c('user'):_c('admin')}
var staticRenderFns = []

export { render, staticRenderFns }